import { ReactComponent as MinusSvg } from '../../../../assets/icons/Minus.svg';

import { createIconComponent } from './createIconComponent';

export const MinusIcon = createIconComponent(MinusSvg);
